import { useState } from "react";
import { MailCheck } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordForm = ({ initialEmail, onClose }) => {
  const [forgotEmail, setForgotEmail] = useState(initialEmail || "");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!forgotEmail) return;
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: forgotEmail });
    } catch { /* always show sent to prevent enumeration */ }
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="mt-6 border-t border-white/10 pt-6" data-testid="forgot-password-form">
      {sent ? (
        <div className="text-center" data-testid="forgot-sent">
          <MailCheck className="h-8 w-8 text-[#FFE800] mx-auto mb-3" />
          <p className="text-sm text-gray-400 mb-1">If an account exists, a reset link has been sent.</p>
          <p className="text-xs text-gray-500">Check your inbox.</p>
          <button onClick={onClose} className="mt-4 text-xs text-gray-500 hover:text-white">Back to sign in</button>
        </div>
      ) : (
        <>
          <p className="text-sm text-gray-400 mb-3">Enter your email to receive a password reset link.</p>
          <div className="flex gap-2">
            <input
              type="email"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              placeholder="Email"
              className="flex-1 bg-black/50 border border-white/20 text-white font-data text-sm py-2 px-3 focus:border-[#FFE800] outline-none"
              data-testid="forgot-email-input"
            />
            <button
              onClick={handleSubmit}
              disabled={loading || !forgotEmail}
              className="border border-[#FFE800] px-4 py-2 text-xs font-headings uppercase text-[#FFE800] hover:bg-[#FFE800]/10 disabled:opacity-40"
              data-testid="forgot-submit"
            >
              {loading ? "..." : "Send"}
            </button>
          </div>
          <button onClick={onClose} className="mt-3 text-xs text-gray-500 hover:text-white" data-testid="forgot-cancel">Cancel</button>
        </>
      )}
    </div>
  );
};

export default ForgotPasswordForm;
